export default __webpack_public_path__ + "static/media/paymentprocessing.ed5f0532.png";